/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricenotset2Inputs */

const en_pricenotset2 = /** @type {(inputs: Pricenotset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price not set`)
};

const de_pricenotset2 = /** @type {(inputs: Pricenotset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis noch nicht festgelegt`)
};

/**
* | output |
* | --- |
* | "Price not set" |
*
* @param {Pricenotset2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pricenotset2 = /** @type {((inputs?: Pricenotset2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricenotset2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricenotset2(inputs)
	return de_pricenotset2(inputs)
});
export { pricenotset2 as "priceNotSet" }